module.exports = __webpack_public_path__ + "img/005.e27e03c7.jpg";